import { render, staticRenderFns } from "./FlockManagement.vue?vue&type=template&id=53bf34ab&"
import script from "./FlockManagement.vue?vue&type=script&lang=js&"
export * from "./FlockManagement.vue?vue&type=script&lang=js&"
import style0 from "./FlockManagement.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports